export default function Dialogs(theme) { 

    const sidebarWidth = 260;

    return {
        MuiDialog: {
            defaultProps: {
                disableEscapeKeyDown: false,
            },
            styleOverrides: {
                root: {
                    left: sidebarWidth
                },
                container: {
                    width: '100%',
                    display: 'flex',
                    justifyContent: 'center',
                },
                paper: {
                    borderRadius: '8px',
                    width: '100%',
                    margin: '16px',
                    [theme.breakpoints.up('md')]: {
                        margin: '50px',
                        width: 'calc(100% - 100px)',
                    },
                },
            },
        },
        MuiDialogTitle: {
            styleOverrides: {
                root: {
                    margin: 0,
                    padding: '10px 20px',
                    fontSize: theme.typography.h4.fontSize,
                    fontWeight: theme.typography.h4.fontWeight,
                    backgroundColor: theme.palette.grey[0],
                    color:theme.palette.text.primary,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                },
            },
        },
        MuiDialogContent: {
            styleOverrides: {
                root: {
                    padding: '24px',
                    backgroundColor: theme.palette.grey[0],
                    '&.overflow-x-hidden': {
                        overflowX: 'hidden',
                    },
                },
                dividers: {
                    borderTop: `1px solid ${theme.palette.divider}`,
                    borderBottom: `1px solid ${theme.palette.divider}`,
                },
            },
        },
        MuiDialogActions: {
            styleOverrides: {
                root: {
                    padding: '16px 24px',
                    justifyContent: 'space-between',
                    borderTop: `1px solid ${theme.palette.divider}`,
                },
            },
        },
    }
}